import { IFli, ItemType } from '@modeso/types__aumico-lib-annualreport-be';

export interface IFLIForNotes extends IFli {
    itemType: ItemType;
    type: string;
}
